/**
 * @author       sarah.walloga@zumper.com (Sarah Walloga)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  index.ts
 */

import { Theme, css } from '@emotion/react'

export const focusRing = ({ colors, spacing, typography }: Theme) => css`
  outline: none;
  border-color: var(--chakra-colors-neutral-500);
  box-shadow: 0 0 0 ${spacing.spacing2} ${colors.neutralLight};
`

export const transition = css`
  transition: all 100ms ease-in;
`
